import { Component, Input } from '@angular/core';

import { checkmarkIcon } from '../../../icons';
import { FieldBaseComponent } from '../field-base/field-base.model';

@Component({
    selector: 'app-checkbox',
    template: `
        <label *ngIf="label; else noLabelTmpl" class="checkbox">
            {{ label }}
            <ng-container *ngTemplateOutlet="checkboxGuts"></ng-container>
        </label>

        <ng-template #noLabelTmpl>
            <div class="checkbox">
                <ng-container *ngTemplateOutlet="checkboxGuts"></ng-container>
            </div>
        </ng-template>

        <ng-template #checkboxGuts>
            <div [formGroup]="parentForm">
                <input [formControlName]="controlName" type="checkbox" [name]="controlName" [id]="controlName" />
                <span class="checkbox__checkmark">
                    ${checkmarkIcon}
                </span>
            </div>
        </ng-template>
    `,
})
export class CheckboxComponent extends FieldBaseComponent {
    @Input() label?: string;

    constructor() {
        super();
    }
}
